import { Speciality } from '../../tables/accreditation/speciality';
import { State } from '../../tables/address/state';
import { Council } from '../../tables/general/council';
import { Firm } from '../../tables/general/firm';
import { Person } from '../../tables/general/person';
import { Participation } from './participation';
import { Performer } from './performer';

export class Professional {
    name: string;
    id: number;
    person: Person;
    council: Council;
    state: State;
    firm: Firm;
    councilNumber: string;
    councilType: string;
    active: boolean;
    staff: boolean;
    specialityList: Speciality[];
    speciality: Speciality;
    participationList: Participation[];
    performer: Performer;
    bankDetail: any;
    supplier: any;
}